import { appSearchParamsToURLSearchParams } from '../appSearchParams';
import { hasParams } from './utils/hasParams';
/**
 * Creates an internal app url.
 *
 * @param options The url options.
 */
export function createAppUrl(options) {
    const { path: pathParams, search: searchParams } = Object.assign({ path: {}, search: {} }, (hasParams(options) && options.params));
    const search = appSearchParamsToURLSearchParams(searchParams).toString();
    return options.path
        .replace(/:(\w+)\??/g, (_, param) => { var _a; return (_a = pathParams[param]) !== null && _a !== void 0 ? _a : ''; })
        .concat(search ? `?${search}` : '');
}
